// import { authActions } from '@shared/redux/ducks/auth';
import { generatedApi } from '@shared/api/generated-api';

export const agentsEndpoints = {
  createAgentAgentCreatePost: {
    invalidatesTags: [],
    async onQueryStarted(_, { dispatch, queryFulfilled, getState }) {
      const { data } = await queryFulfilled;

      const cachedAgentListArgs = generatedApi.util.selectCachedArgsForQuery(
        getState(),
        'getAgentListAgentListGet',
      );

      for (const args of cachedAgentListArgs) {
        dispatch(
          generatedApi.util.updateQueryData('getAgentListAgentListGet', args, (draft) => {
            const alreadyExists = draft.some((item) => item.id === data.id);
            if (!alreadyExists) {
              draft.unshift(data);
            }
          }),
        );
      }
    },
  },

  updateAgentAgentUpdatePost: {
    invalidatesTags: [],
    async onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
      const { data } = await queryFulfilled;

      const cachedAgentListArgs = generatedApi.util.selectCachedArgsForQuery(
        getState(),
        'getAgentListAgentListGet',
      );

      const cachedArgs = generatedApi.util.selectCachedArgsForQuery(
        getState(),
        'getAgentInfoAgentInfoGet',
      );

      for (const args of cachedAgentListArgs) {
        dispatch(
          generatedApi.util.updateQueryData('getAgentListAgentListGet', args, (draft) => {
            const idx = draft.findIndex((item) => item.id === arg.agentId);

            if (idx !== -1) {
              draft[idx] = data;
            }
          }),
        );
      }

      for (const queryArg of cachedArgs) {
        if (queryArg.agentId !== arg.agentId) continue;

        dispatch(
          generatedApi.util.updateQueryData('getAgentInfoAgentInfoGet', queryArg, (draft) => {
            Object.assign(draft, data);
          }),
        );
      }
    },
  },

  agentFieldCreateAgentFieldCreatePost: {
    invalidatesTags: [],
    async onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
      try {
        const { data: createdField } = await queryFulfilled;

        const cachedArgs = generatedApi.util.selectCachedArgsForQuery(
          getState(),
          'getAgentInfoAgentInfoGet',
        );

        for (const queryArg of cachedArgs) {
          if (queryArg.agentId !== arg.agentId) continue;

          dispatch(
            generatedApi.util.updateQueryData('getAgentInfoAgentInfoGet', queryArg, (draft) => {
              draft.agent_fields ??= [];

              const idx = draft.agent_fields.findIndex((f) => f.id === createdField.id);
              if (idx === -1) {
                draft.agent_fields.push(createdField);
              } else {
                draft.agent_fields[idx] = createdField;
              }
            }),
          );
        }

        const cachedFieldsValuesArgs = generatedApi.util.selectCachedArgsForQuery(
          getState(),
          'getUserAgentFieldsAgentTestFieldsValuesGet',
        );

        for (const queryArg of cachedFieldsValuesArgs) {
          dispatch(
            generatedApi.endpoints.getUserAgentFieldsAgentTestFieldsValuesGet.initiate(queryArg, {
              forceRefetch: true,
              subscribe: false,
            }),
          );
        }
      } catch {}
    },
  },

  agentFieldUpdateAgentFieldUpdatePost: {
    invalidatesTags: [],
    async onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
      try {
        const { data: updatedField } = await queryFulfilled;

        const cachedArgs = generatedApi.util.selectCachedArgsForQuery(
          getState(),
          'getAgentInfoAgentInfoGet',
        );

        for (const queryArg of cachedArgs) {
          dispatch(
            generatedApi.util.updateQueryData('getAgentInfoAgentInfoGet', queryArg, (draft) => {
              if (!draft.agent_fields?.length) return;

              const idx = draft.agent_fields.findIndex(
                (f) => f.id === updatedField.id || f.id === arg.agentFieldId,
              );

              if (idx !== -1) {
                draft.agent_fields[idx] = updatedField;
              }
            }),
          );
        }

        const cachedFieldsValuesArgs = generatedApi.util.selectCachedArgsForQuery(
          getState(),
          'getUserAgentFieldsAgentTestFieldsValuesGet',
        );

        for (const queryArg of cachedFieldsValuesArgs) {
          dispatch(
            generatedApi.endpoints.getUserAgentFieldsAgentTestFieldsValuesGet.initiate(queryArg, {
              forceRefetch: true,
              subscribe: false,
            }),
          );
        }
      } catch {}
    },
  },

  agentFieldDeleteAgentFieldDelete: {
    invalidatesTags: [],
    async onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
      try {
        await queryFulfilled;

        const cachedArgs = generatedApi.util.selectCachedArgsForQuery(
          getState(),
          'getAgentInfoAgentInfoGet',
        );

        for (const queryArg of cachedArgs) {
          dispatch(
            generatedApi.util.updateQueryData('getAgentInfoAgentInfoGet', queryArg, (draft) => {
              if (!draft.agent_fields?.length) return;

              const idx = draft.agent_fields.findIndex((f) => f.id === arg.agentFieldId);

              if (idx !== -1) {
                draft.agent_fields.splice(idx, 1);
              }
            }),
          );
        }

        const cachedFieldsValuesArgs = generatedApi.util.selectCachedArgsForQuery(
          getState(),
          'getUserAgentFieldsAgentTestFieldsValuesGet',
        );

        for (const queryArg of cachedFieldsValuesArgs) {
          dispatch(
            generatedApi.endpoints.getUserAgentFieldsAgentTestFieldsValuesGet.initiate(queryArg, {
              forceRefetch: true,
              subscribe: false,
            }),
          );
        }
      } catch {}
    },
  },

  deleteAgentAgentDeleteDelete: {
    invalidatesTags: [],
    async onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
      await queryFulfilled;

      const cachedAgentListArgs = generatedApi.util.selectCachedArgsForQuery(
        getState(),
        'getAgentListAgentListGet',
      );
      const cachedAgentInfoArgs = generatedApi.util.selectCachedArgsForQuery(
        getState(),
        'getAgentInfoAgentInfoGet',
      );

      for (const args of cachedAgentListArgs) {
        dispatch(
          generatedApi.util.updateQueryData('getAgentListAgentListGet', args, (draft) => {
            const index = draft.findIndex((item) => item.id === arg.agentId);
            if (index !== -1) {
              draft.splice(index, 1);
            }
          }),
        );
      }

      for (const queryArg of cachedAgentInfoArgs) {
        dispatch(
          generatedApi.util.updateQueryData('getAgentInfoAgentInfoGet', queryArg, (draft) => {
            if (!draft.agent_links?.length) return;

            draft.agent_links = draft.agent_links.filter(
              (link) => link.target_agent_id !== arg.agentId,
            );
          }),
        );
      }
    },
  },

  getAgentListAgentListGet: {
    providesTags: ['agent'] as const,
  },

  getAgentInfoAgentInfoGet: {
    providesTags: ['agent'] as const,
  },
} satisfies Parameters<typeof generatedApi.enhanceEndpoints>[0]['endpoints'];
